import { create } from "zustand";
import {
  createJSONStorage,
  persist,
  subscribeWithSelector,
} from "zustand/middleware";

import {
  PRIMARY_NAVIGATION_DEFAULT_WIDTH,
  PRIMARY_NAVIGATION_MAX_WIDTH,
  PRIMARY_NAVIGATION_MIN_WIDTH,
} from "./constants";

interface NavigationState {
  primaryNavigationVariant: "temporary" | "permanent";
  setPrimaryNavigationVariant: (variant: "temporary" | "permanent") => void;
  makePrimaryNavigationTemporary: () => void;
  makePrimaryNavigationPermanent: () => void;
  primaryNavigationWidth: number;
  setPrimaryNavigationWidth: (width: number) => void;
  isPrimaryNavigationExpanded: boolean;
  setIsPrimaryNavigationExpanded: (expanded: boolean) => void;
  expandPrimaryNavigation: () => void;
  collapsePrimaryNavigation: () => void;
  activeWorkspaceName: string | null;
  setActiveWorkspaceName: (
    workspaceName: NavigationState["activeWorkspaceName"],
  ) => void;
  resetStore: () => void;
}

export const useNavigationStore = create<NavigationState>()(
  persist(
    subscribeWithSelector((set) => ({
      primaryNavigationVariant: "permanent",
      primaryNavigationWidth: PRIMARY_NAVIGATION_DEFAULT_WIDTH,

      isPrimaryNavigationExpanded: false,
      activeWorkspaceName: null,

      setPrimaryNavigationVariant: (
        primaryNavigationVariant: "temporary" | "permanent",
      ) => {
        set({ primaryNavigationVariant });
      },
      makePrimaryNavigationTemporary: () => {
        set({
          primaryNavigationVariant: "temporary",
          isPrimaryNavigationExpanded: false,
        });
      },
      makePrimaryNavigationPermanent: () => {
        set({
          primaryNavigationVariant: "permanent",
          isPrimaryNavigationExpanded: false,
        });
      },

      setPrimaryNavigationWidth: (width: number) => {
        set({
          primaryNavigationWidth: Math.max(
            Math.min(width, PRIMARY_NAVIGATION_MAX_WIDTH),
            PRIMARY_NAVIGATION_MIN_WIDTH,
          ),
        });
      },

      setIsPrimaryNavigationExpanded: (
        isPrimaryNavigationExpanded: boolean,
      ) => {
        set({
          primaryNavigationVariant: "temporary",
          isPrimaryNavigationExpanded,
        });
      },
      expandPrimaryNavigation: () => {
        set({
          primaryNavigationVariant: "temporary",
          isPrimaryNavigationExpanded: true,
        });
      },
      collapsePrimaryNavigation: () => {
        set({
          primaryNavigationVariant: "temporary",
          isPrimaryNavigationExpanded: false,
        });
      },

      setActiveWorkspaceName: (activeWorkspaceName) => {
        set({ activeWorkspaceName });
      },

      resetStore: () => {
        set({
          isPrimaryNavigationExpanded: false,
          activeWorkspaceName: null,
        });
      },
    })),
    {
      version: 1,
      name: "nav",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
